function ErrorMessage(props) {
  return (
    <div className="error-message">
      <h1>Error {props.message}</h1>
    </div>
  );
}

export default ErrorMessage;
